import styled, { createGlobalStyle } from "styled-components";
import { Layout } from 'antd';

const { Sider } = Layout;

export const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 40px);
    overflow-y: auto;
    overflow-x: hidden;
`;

export interface ContentLayoutProps {
  collapsed?: boolean;
}

export const ContentLayout = styled.div<ContentLayoutProps>`
  margin: 0;
  background-color: #FBFBFB;
  max-width: ${props => props.collapsed ? 'calc(100vw - 80px)' : 'calc(100vw - 205px)'};
  width: ${props => props.collapsed ? 'calc(100vw - 80px)' : 'calc(100vw - 205px)'};
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    max-width: 100vw;
    width: 100vw;
  }
`;

export const StickySider = styled(Sider)`
  position: sticky;
  height: calc(100dvh);
  overflow: hidden;
  z-index: 999; /* Higher z-index to ensure it appears above other elements */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); */
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 50px; /* Height of the header */
    left: 0;
    height: calc(100dvh - 50px);
    transform: ${props => props.collapsed ? 'translateX(-100%)' : 'translateX(0)'};
    width: 250px !important; /* Force width on mobile */
    min-width: 250px !important;
    max-width: 80vw !important;
  }
`;

export const SidebarLogoContainer = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow: hidden;
  background: white;
  cursor: pointer;
  img {
    max-width: 100%;
    max-height: 40px;
    object-fit: contain;
  }
  
  @media (max-width: 768px) {
    padding: 16px 24px;
    justify-content: flex-start;
  }
`;

export const CollapseButton = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 11;
  
  @media (max-width: 768px) {
    display: none; /* Hide collapse button on mobile */
  }
`;

export const Overlay = styled.div<{ visible: boolean }>`
  display: ${props => props.visible ? 'block' : 'none'};
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998; /* Just below the sidebar */
  transition: opacity 0.3s ease;
  opacity: ${props => props.visible ? 1 : 0};
  
  @media (min-width: 769px) {
    display: none;
  }
`;

// Global styles for sidebar menu
export const GlobalSidebarStyles = createGlobalStyle`

  /* Position submenus relative to the sidebar */
  .StickySider .ant-menu-submenu-popup {
    position: absolute !important;
  }

  /* Add scrolling for long submenus */
  .ant-menu-submenu-popup .ant-menu {
    max-height: 50vh !important;
    overflow-y: auto !important;
  }

  /* Force submenus to appear above for items in bottom half of sidebar */
  .StickySider .ant-menu-submenu:nth-last-child(-n+5) .ant-menu-submenu-popup {
    top: auto !important;
    bottom: 0 !important;
  }

  /* Adjust popup position for vertical mode */
  .sidebar-menu-collapsed .ant-menu-submenu-popup {
    left: 80px !important;
  }

  /* Ensure submenus don't overflow the viewport */
  .ant-menu-submenu-popup {
    overflow: visible !important;
  }

  /* Fix for submenus that would extend beyond the bottom of the viewport */
  .ant-menu-submenu-popup.ant-menu-submenu-placement-bottomLeft,
  .ant-menu-submenu-popup.ant-menu-submenu-placement-bottomRight {
    margin-top: -200px !important;
  }

  /* Ensure submenus for profile section appear above */
  .sidebar-menu .ant-menu-submenu:last-child .ant-menu-submenu-popup {
    bottom: 50px !important;
    top: auto !important;
  }

  /* Highlight parent menu items when they are selected (when child is active) */
  .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title {
    background-color: #e6f4ff !important;
  }

  /* Also apply hover effect to selected parent items in inline mode */
  .ant-menu-inline .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title:hover {
    background-color: #bae0ff !important;
  }

  /* For vertical/collapsed mode */
  .ant-menu-vertical .ant-menu-submenu.ant-menu-submenu-selected > .ant-menu-submenu-title {
    background-color: #e6f4ff !important;
  }
`;
